/**
 * @function to set and get FIFO defaults
 * @param receiverCountry 
 * @returns fundsin, fundsout
 */

const FifoService = (function () {
    let getInstance, setInstance, initObj = {},
        fifoDefaultObj = {},
        onPageLoad = true,
        isCurrencyConverter;

    function getParamFromUrl() {
        let params = window.location.search || window.location.hash //"?FundsOut=BA&FundsIn=POLI";
        onPageLoad = false;
        if(params.includes('FundsIn=') && params.includes('FundsOut=') ){
            return params;
        }
        else{
            return null;
        }
    }

    function getTopCorridorElement() {
        const elem = document.getElementById(`corridor_countries`) ? document.getElementById(`corridor_countries`).innerHTML : null;
        const topCorridorList = elem ===`[]` ? null : elem; // if top 20 corridors are there, then we have [] in the script.
        return topCorridorList;
    }

    function getTopCorridorListFromHtml() {
        const getTopCorridorObj = getTopCorridorElement();
        const countriesObj = getTopCorridorObj && JSON.parse(getTopCorridorObj);
        return countriesObj
    }

    function getURLParameter(name) {
        const urlParams = getParamFromUrl();
        let returnValue = urlParams && decodeURIComponent((new RegExp(`[?|&]` + name + `=` + `([^&;]+?)(&|#|;|$)`).exec(urlParams) || [, ""])[1].replace(/\+/g, `%20`)) || null
        if (returnValue) {
            returnValue = returnValue.trim();
        }
        return returnValue;
    }

    function findValue(o, value) {
        for (let prop in o) {
            if (o.hasOwnProperty(prop) && o[prop] === value) {
                return prop;
            }
        }
        return null;
    }

    function queryParamConfig(name) {
        let arrParamFiFo = [`FundsOut`, `FundsIn`]
        let queryParamObj = {}
        arrParamFiFo.forEach(element => {
            queryParamObj[element] = getURLParameter(element)
        });
        queryParamObj.FundsIn = findValue(CloudPayIn, queryParamObj.FundsIn);
        queryParamObj.FundsOut = findValue(CloudPayOut, queryParamObj.FundsOut);
        return queryParamObj;
    }


    function pageLevelConfig() {
        return initObj;
    }

    function checkTopCorridorConfig(sendToCountry) {
        const countriesObj = getTopCorridorListFromHtml()
        const receiverCountry = countriesObj && countriesObj[sendToCountry.toLowerCase()];
        if (receiverCountry) {
            return receiverCountry;
        }
    }

    function smoConfig(countryCode) {
        let smoConfigObj = {};
        const fifoDefaultsObj = fifoDefaults.find(c => c.isoCode.toLowerCase() === countryCode.toLowerCase());
        smoConfigObj.FundsIn = findValue(CloudPayIn, fifoDefaultsObj.fundsIn);
        smoConfigObj.FundsOut = findValue(CloudPayOut, fifoDefaultsObj.fundsOut);
        return smoConfigObj;
    }

    function setFifoDefault(fifoType, sendToCountry) {
        const PAGE_LEVEL = `page_level`, TOP_20_CORRIDORS = `top_20_corridor`, QUERY_PARAM = `query_param`

        switch (fifoType) {
            case PAGE_LEVEL :
                fifoDefaultObj.FifoValue = pageLevelConfig();
                break;

            case TOP_20_CORRIDORS :
                fifoDefaultObj.FifoValue = checkTopCorridorConfig(sendToCountry);
                if (fifoDefaultObj.FifoValue === undefined) {
                    fifoDefaultObj.FifoValue = pageLevelConfig();
                    fifoDefaultObj.type = `page_level`;
                }
                break;

            case QUERY_PARAM :
                fifoDefaultObj.FifoValue = queryParamConfig();
                break;

            default :
                fifoDefaultObj.FifoValue = smoConfig(sendToCountry);
                break;
        }
        return fifoDefaultObj
    }

    function getFifoType() {
        let topCorridorObj = getTopCorridorElement();
        let getUrlParam = onPageLoad && !isCurrencyConverter && getParamFromUrl();

        if (
            getUrlParam // FIFO coming from query param
        ) {
            fifoDefaultObj.type = `query_param`

        } else if (
            topCorridorObj && topCorridorObj.length !== 0 //FIFO coming from top corridor FIFO
        ) {
            fifoDefaultObj.type = `top_20_corridor`

        } else if (
            topCorridorObj == null || topCorridorObj.length == 0 //FIFO coming from page level
        ) {
            fifoDefaultObj.type = `page_level`

        } else {
            fifoDefaultObj.type = `smo_config` // FIFO coming from SMO-config
        }

        return fifoDefaultObj.type;
    }

    function getFifoOnCountrySelection(sendToCountry) {
        let fifoType = getFifoType()
        return setFifoDefault(fifoType, sendToCountry);
    }

    function init(fo, fi) {
        initObj.FundsOut = fo;
        initObj.FundsIn = fi;
        return initObj;
    }

    return {
        setFifo: function (fo, fi) {
            setInstance = init(fo, fi);
            return setInstance;
        },
        getFifo: function (sendToCountry, isCurrConverter) {
            isCurrencyConverter = isCurrConverter;
            getInstance = getFifoOnCountrySelection(sendToCountry);
            return getInstance;
        }
    };
})();